import {
  EnterprisePolicyResponse,
  TlxPaginatedResponseModel_EnterprisePolicyResponse,
} from "@/api";
import enterprisePoliciesSeed from "./seed";

class EnterprisePoliciesStore {
  private items: EnterprisePolicyResponse[] = structuredClone(enterprisePoliciesSeed);

  list(params?: {
    enabled?: boolean;
    name?: string;
    page?: number;
    size?: number;
    status?: string;
  }): TlxPaginatedResponseModel_EnterprisePolicyResponse {
    const nameFilter = String(params?.name ?? "").trim().toLowerCase();
    const statusFilter = String(params?.status ?? "").trim().toLowerCase();
    const pageNo = Math.max(0, Number(params?.page ?? 0));
    const pageSize = Math.max(1, Number(params?.size  || 10));

    const filtered = this.items.filter(item => {
      const matchesEnabled =
        typeof params?.enabled === "boolean"
          ? Boolean(item.enabled) === params.enabled
          : true;
      const matchesName = nameFilter
        ? String(item.name ?? "").toLowerCase().includes(nameFilter)
        : true;
      const matchesStatus = statusFilter
        ? String(item.status ?? "").toLowerCase() === statusFilter
        : true;

      return matchesEnabled && matchesName && matchesStatus;
    });

    const start = pageNo * pageSize;
    const end = start + pageSize;

    return {
      items: filtered.slice(start, end),
      pageNo,
      pageSize,
      total: filtered.length,
    };
  }

  create(params?: Record<string, unknown>): EnterprisePolicyResponse {
    const body = (params?.body ?? params ?? {}) as Record<string, unknown>;
    const policyName = String(
      body.name ?? body.policyName ?? "Enterprise Policy",
    ).trim();
    const description = String(
      body.description ?? body.businessDescription ?? "",
    ).trim();
    const now = new Date();

    const policy: EnterprisePolicyResponse = {
      id: `ent-pol-${Date.now()}`,
      name: policyName || "Enterprise Policy",
      description,
      status: "POLICY_SAVED",
      enabled: false,
      createdDate: now,
      lastModifiedDate: now,
    };

    this.items.unshift(policy);
    return policy;
  }

  reset(): void {
    this.items = structuredClone(enterprisePoliciesSeed);
  }
}

export const enterprisePoliciesStore = new EnterprisePoliciesStore();
